export const FETCH_DRIVERS_DOCUMENTS_DATA = "FETCH_DRIVERS_DOCUMENTS_DATA";
export const FETCH_DRIVERS_DOCUMENTS_SUCCESS = "FETCH_DRIVERS_DOCUMENTS_SUCCESS";
export const FETCH_DRIVERS_DOCUMENTS_FAILURE = "FETCH_DRIVERS_DOCUMENTS_FAILURE";